import request from '@/request'
export function getList(data) {
    return request({	//文章列表
        url: 'article/list',
        method: 'POST',
        data: data
    })
}
// export function getChildList(params) {
//     return request({	//子列表
//         url: 'site/article/child/list',
//         method: 'get',
//         params: params
//     })
// }
export function message(data) { //留言
	return request({
		url: `message_board`,
		method: 'post',
		data: data
	})
}
export function menuList(params) {
    return request({	//顶部菜单栏目
        url: `menu/tree`,
        method: 'get',
        params: params
    })
}